// Assamese translations
export const as: Record<string, string> = {
  "menu.dashboard": "ডেশ্বব'ৰ্ড",
  "menu.customers": "গ্ৰাহক",
  "menu.products": "সামগ্ৰী",
  "menu.users": "ব্যৱহাৰকাৰী",
  "menu.settings": "ছেটিংছ",
  "menu.logout": "লগআউট",
  "dashboard.title": "ডেশ্বব'ৰ্ড",
  "dashboard.newOrder": "নতুন অৰ্ডাৰ",
  "order.title": "নতুন অৰ্ডাৰ",
  "order.customer": "গ্ৰাহক",
  "order.products": "সামগ্ৰী",
  "order.total": "মুঠ",
  "users.title": "ব্যৱহাৰকাৰী",
  "users.name": "নাম",
  "users.email": "ইমেইল",
  "common.yes": "হয়",
  "common.no": "নহয়",
  "common.cancel": "বাতিল কৰক",
  "common.save": "সংৰক্ষণ কৰক",
  "common.search": "সন্ধান কৰক",
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  "login.title": "Cleandy",
  "login.login": "লগইন",
  "login.welcome": "স্বাগতম, {name}",
  "signup.email": "ইমেইল",
  "signup.phone": "ফোন",
  'menu.reportsAndAccounting': 'প্ৰতিবেদন আৰু হিচাপ',
  'menu.systemAndCommunication': 'ব্যৱস্থা আৰু যোগাযোগ',
};